import React, { useEffect, useState, useRef } from 'react';
import Input from '../components/Input';
import Text from '../components/Text';

function Panel(props) {
    const [value, setValue] = useState(null);

    const classes = props.classes || null;
    const text = props.text || 'text';
    const src = props.src || 'src';
    const placeholder = props.placeholder || 'default';
    const handleChange = props.handleChange || null;
    const name = props.name || null;

    return (
        <div className={classes}  >
            <Text text={text} classes="w-text-default" />
            {/* <img src={process.env.PUBLIC_URL + '/img/categories/animaux.png'} alt={text} /> */}
            <img src={process.env.PUBLIC_URL + '' + src} alt={text} />
            <input
                onChange={(e) => { setValue(e.target.value); handleChange(e) }}
                name={name}
                value={value}
                type="text"
                placeholder={placeholder}
                className="w-input-sm" 
                />
        </div>
    );
}

export default Panel;